<template>
  <div class="stacked-images-container">
    <div
      v-for="(image, index) in images"
      :key="index"
      class="image-wrapper"
      :class="{ 'is-active': selectedImage === index }"
      :style="getImageStyle(index)"
      @mouseover="selectImage(index)"
      @mouseleave="deselectImage()"
      @click="toggleImage(index)"
    >
      <img :src="image.src" :alt="image.alt" class="stacked-image" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'StackedImages',
  props: {
    images: {
      type: Array,
      required: true,
      validator: (value) => value.length > 0
    }
  },
  data() {
    return {
      // Posições pré-definidas para as imagens
      positions: [
        { top: '0px', left: '0px', rotate: '-5deg', zIndex: 4 },
        { top: '50px', left: '25px', rotate: '2deg', zIndex: 3 },
        { top: '100px', left: '50px', rotate: '6deg', zIndex: 2 },
        { top: '115px', left: '80px', rotate: '10deg', zIndex: 1 },
        { top: '20px', left: '10px', rotate: '-2deg', zIndex: 5 },
        { top: '70px', left: '35px', rotate: '4deg', zIndex: 6 },
        { top: '120px', left: '60px', rotate: '8deg', zIndex: 7 },
        { top: '135px', left: '90px', rotate: '12deg', zIndex: 8 },
      ],
      selectedImage: null,
    };
  },
  methods: {
    getImageStyle(index) {
      const pos = this.positions[index % this.positions.length];
      return {
        top: pos.top,
        left: pos.left,
        transform: `rotate(${pos.rotate})`,
        zIndex: pos.zIndex,
      };
    },
    selectImage(index) {
      this.selectedImage = index;
    },
    deselectImage() {
      this.selectedImage = null;
    },
    toggleImage(index) {
      // Se a imagem clicada já está selecionada, deseleciona. Senão, seleciona a nova.
      this.selectedImage = this.selectedImage === index ? null : index;
    }
  }
};
</script>

<style scoped>
.stacked-images-container {
  position: relative;
  width: 300px;
  height: 400px;
}

.image-wrapper {
  position: absolute;
  width: 250px;
  height: 300px;
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
  transition: transform 0.3s ease, z-index 0.3s ease;
  cursor: pointer; /* Adiciona um cursor de mão para indicar que é clicável */
}

/* Estado de HOVER para desktop */
.image-wrapper:hover {
  transform: scale(1.05) !important;
  z-index: 10 !important;
}

/* Estado de ATIVO para mobile e desktop */
.image-wrapper.is-active {
  transform: scale(1.05) !important;
  z-index: 10 !important;
}

.stacked-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

/* Ajustes para mobile */
@media (max-width: 921px) {
  .stacked-images-container {
    width: 250px;
    height: 350px;
  }
  .image-wrapper {
    width: 200px;
    height: 250px;
  }
}
</style>